import { useSelector } from 'react-redux'

export function useNumberFormat(options?: Intl.NumberFormatOptions): Intl.NumberFormat {
  const locale = useSelector<State, string>((state) => state.getIn(['shop', 'locale'], '').replace('_', '-'))
  return new Intl.NumberFormat(locale, options)
}
